import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const ThemeSettingsInput = ({ className, label, onChange, options, type, value, disabled }) => {
    const componentClass = 'themeSettingsInput';
    const classes = classnames(componentClass, 'formInput', {
        className: !!className,
    });

    const onOptionValueChange = e => {
      const { value: newValue } = e.target;
      onChange(newValue);
    };

    const onInputValueChange = e => {
      onChange(e.target.checked);
    };

    const onValueChange = e => {
      onChange(e.target.value);
    };

    return (
        <div className={classes}>
            <label>{ label }</label>
            { 
              type === 'dropdown'
              ? <select value={value} onChange={onOptionValueChange}>
                  { (options || []).map(option => (
                    <option key={option.key} value={option.key}>{option.label}</option>
                  ))}
                </select>
              : type === 'checkbox'
              ? <input disabled={disabled} type="checkbox" checked={value} onChange={onInputValueChange} />
              : type === 'textarea'
              ? <textarea disabled={disabled} onChange={onValueChange}>{value}</textarea>
              : type === 'input'
              ? <input disabled={disabled} type="text" value={value} onChange={onValueChange} />
              // default case: text input
              : <input disabled={disabled} type="text" value={value} onChange={onValueChange} />
            }
        </div>
    );
};

ThemeSettingsInput.propTypes = {
    value: PropTypes.any,
    key: PropTypes.any.isRequired,
    onChange: PropTypes.func,
    type: PropTypes.oneOf([ 'input', 'textarea', 'dropdown' ,'checkbox' ]),
    options: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.any,
        label: PropTypes.string
    }))
};
export default ThemeSettingsInput;
